/* eslint-disable prefer-destructuring */
import styled, { css } from "styled-components";
import { type DisplayProps, display } from "styled-system";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as CommonNavigationStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Navigation";
import Container from "../../../../../../../../common-deprecated/styles/lexus/Container";

// This extra padding is necessary when the stickywrapper is fixed, otherwise part of the content is hidden underneath the bar
export const DesktopStickyPadding = styled.div<DisplayProps & { gradeNavHeight: number }>`
    height: ${({ gradeNavHeight }) => gradeNavHeight + CommonNavigationStyles.NAV_HEIGHT_MOBILE}px;
    ${display};

    @media ${getBreakpoint("up", "lg")} {
        height: ${({ gradeNavHeight }) => gradeNavHeight + CommonNavigationStyles.NAV_PRIMARY_HEIGHT}px;
    }
`;

export const StickyWrapper = CommonNavigationStyles.StickyWrapper;

export const NavContainer = styled(Container)``;

export const NavWrapper = styled.div`
    display: flex;
    position: relative;
    flex-grow: 1;
    align-items: center;
`;

export const BackButton = CommonNavigationStyles.BackButton;

export const DesktopNav = CommonNavigationStyles.DesktopNav;

export const MobileNav = CommonNavigationStyles.MobileNav;

export const MobileNavHeader = CommonNavigationStyles.MobileNavHeader;

export const MobileNavButton = CommonNavigationStyles.MobileNavButton;

export const Badge = CommonNavigationStyles.Badge;

export const StepText = CommonNavigationStyles.StepText;

export const FloatingNav = styled(CommonNavigationStyles.NavigationDropdown)<{ visible: boolean }>`
    border-top: 1px solid ${theme.colors.platinumDark};
    /* We want to give the impression the basket collapses, without squishing the everything to much it because ugly,
    so we only scale down to 75% and make the scaling animation take a bit longer so it still looks like its animating at when its almost faded out */
    transform-origin: top center;
    transition:
        opacity 0.3s,
        transform 0.4s;
    ${({ visible }) => css`
        /* transform should be none when it's done animating so we don't unnecessarily use the GPU to render the contents */
        transform: ${visible ? "none" : "scaleY(0.75)"};
        opacity: ${visible ? 1 : 0};
        pointer-events: ${visible ? "initial" : "none"};
    `}
`;
